import React from "react";
import { useChartsStore } from "../../store/chartStore";
import useWorkspaceStore from "../../store/workspaceStore";
import useBookByPriceStore from "../../store/bookByPriceStore";
import SymbolSpotlight, { PANEL_CAPABILITIES } from "./SymbolSpotlight";
import { symbolSpotlightRef } from "./symbolSpotlightRef";

const SymbolDropdown = () => {
  // Shared module-level ref — also used by the chart context menu ("Símbolo…")
  const spotlightRef = symbolSpotlightRef;
  const selectedChartSymbol = useChartsStore(
    (state) => state.getSelectedChart()?.symbol || null,
  );
  const bookByPriceSymbol = useBookByPriceStore((state) => state.symbol);
  const focusedPanelType = useWorkspaceStore((state) => state.focusedPanelType);
  const capabilities =
    PANEL_CAPABILITIES[focusedPanelType] || PANEL_CAPABILITIES.chart;
  const isMultiSymbolPanel = focusedPanelType === "grid";
  const selectedSymbol =
    focusedPanelType === "bookByPrice"
      ? bookByPriceSymbol
      : selectedChartSymbol;
  const showSymbol =
    capabilities.includes("symbol") && !isMultiSymbolPanel
      ? selectedSymbol
      : null;

  const handleDropdownClick = () => {
    spotlightRef.current?.open();
  };

  return (
    <>
      <SymbolSpotlight ref={spotlightRef} />

      {/* Simple display of current symbol */}
      <div
        className="custom-dropdown navbar-button"
        onClick={handleDropdownClick}
        style={{
          width: "140px",
          textAlign: "left",
          padding: "8px 12px",
          background: "transparent",
          color: "var(--text-color)",
          cursor: "pointer",
        }}
        data-evo-id="navbar-symbol-dropdown-toggle"
      >
        <div className="navbar-item-content">
          <i className="pi pi-search navbar-item-icon"></i>
          <span className="navbar-item-label">
            {showSymbol ||
              (isMultiSymbolPanel
                ? "Adicionar símbolo..."
                : "Selecione um Ativo")}
          </span>
        </div>
      </div>

      {/* Old dropdown code commented out */}
      {/*
            <Dropdown
                ref={dropdownRef}
                value={selectedSymbol}
                onChange={handleChange}
                options={options}
                virtualScrollerOptions={{ itemSize: 50 }}
                optionLabel="I"
                placeholder="Selecione um Ativo"
                filter
                filterBy="I,D"
                valueTemplate={selectedSymbolTemplate}
                itemTemplate={symbolOptionTemplate}
                className="custom-dropdown navbar-button"
                style={{
                    width: '140px',
                    textAlign: 'left',
                    display: 'flex',
                    alignItems: 'center',
                    border: 'none',
                    borderRadius: '0px',
                }}
                panelStyle={{ width: '260px' }}
                onShow={handleDropdownShow}
                onHide={handleDropdownHide}
            />
            {isDropdownOpen && isFilterHovered && (
                <div
                    style={{
                        position: 'fixed',
                        left: 'calc(50vw - 150px)', // adjust as needed for your layout
                        top: '80px', // adjust as needed for your navbar/dropdown position
                        background: '#fff',
                        color: '#333',
                        border: '1px solid #ddd',
                        borderRadius: '4px',
                        boxShadow: '0 2px 16px rgba(0,0,0,0.18)',
                        padding: '8px 12px',
                        zIndex: 99999,
                        fontSize: '0.95em',
                        maxWidth: '320px',
                        pointerEvents: 'none'
                    }}
                >
                    Dica: você pode digitar <b>apenas o símbolo</b> (ex: PETR4), <b>apenas a periodicidade</b> (ex: 5, 1D, 1W), ou <b>símbolo + periodicidade</b> (ex: PETR4 5, VALE3 1D).
                </div>
            )}
            */}
    </>
  );
};

export default React.memo(SymbolDropdown);
